const REACT_APP_VERSION = "0.0.11";

export const displayVersion = () => {
    const asciiArt = `
    ╔══════════════════════════════════════════════════╗
    ║                                                  ║
    ║   ███████╗██████╗  █████╗                        ║
    ║   ██╔════╝██╔══██╗██╔══██╗                       ║
    ║   ███████╗██████╔╝███████║                       ║
    ║   ╚════██║██╔═══╝ ██╔══██║                       ║
    ║   ███████║██║     ██║  ██║                       ║
    ║   ╚══════╝╚═╝     ╚═╝  ╚═╝                       ║
    ║                                                  ║
    ║                  Version: ${REACT_APP_VERSION}                 ║
    ║                                                  ║
    ╚══════════════════════════════════════════════════╝
  `;

  console.log(asciiArt);
};
